// Centralized data-testid constants for testing
export const TESTIDS = {
  // Layout
  siteHeader: "site-header",
  siteFooter: "site-footer",
  navHome: "nav-home",
  navPlay: "nav-play",
  navLearn: "nav-learn",
  navRules: "nav-rules",
  navVariants: "nav-variants",
  navStats: "nav-stats",
  navSettings: "nav-settings",
  themeToggle: "theme-toggle",
  mobileMenuToggle: "mobile-menu-toggle",

  // Home
  homePage: "home-page",
  playNowBtn: "play-now-btn",
  learnRulesBtn: "learn-rules-btn",
  continueGameBtn: "continue-game-btn",
  variantCard: (id) => `variant-card-${id}`,
  installPwaBtn: "install-pwa-btn",

  // Play / Mode select
  playModePage: "play-mode-page",
  modeSingleBtn: "mode-single-btn",
  modeLocalBtn: "mode-local-btn",
  modePracticeBtn: "mode-practice-btn",
  difficultyBeginner: "difficulty-beginner",
  difficultyIntermediate: "difficulty-intermediate",
  difficultyAdvanced: "difficulty-advanced",
  startGameBtn: "start-game-btn",

  // Game page
  gamePage: "game-page",
  gameBoard: "game-board",
  pit: (r, c) => `pit-r${r}-c${c}`,
  captureTrayA: "capture-tray-a",
  captureTrayB: "capture-tray-b",
  hudCurrentPlayer: "hud-current-player",
  hudRuleset: "hud-ruleset",
  hudPhase: "hud-phase",
  hudCapturesA: "hud-captures-a",
  hudCapturesB: "hud-captures-b",
  hudTurn: "hud-turn",
  undoBtn: "undo-btn",
  restartBtn: "restart-btn",
  rematchBtn: "rematch-btn",
  homeBtn: "home-btn",
  reviewBtn: "review-btn",
  shareBtn: "share-btn",
  moveExplanation: "move-explanation",
  eventLog: "event-log",
  resultDialog: "result-dialog",
  resultWinner: "result-winner",
  resultReason: "result-reason",
  confirmMoveBtn: "confirm-move-btn",
  cancelMoveBtn: "cancel-move-btn",

  // Tutorial
  learnPage: "learn-page",
  tutorialStep: (n) => `tutorial-step-${n}`,
  tutorialNextBtn: "tutorial-next-btn",
  tutorialPrevBtn: "tutorial-prev-btn",
  tutorialRestartBtn: "tutorial-restart-btn",

  // Rules / Variants
  rulesPage: "rules-page",
  variantsPage: "variants-page",
  ruleCountry: (slug) => `rule-country-${slug}`,
  rulesetItem: (id) => `ruleset-item-${id}`,

  // Statistics
  statsPage: "stats-page",
  statsReset: "stats-reset-btn",

  // Settings
  settingsPage: "settings-page",
  settingSound: "setting-sound",
  settingMusic: "setting-music",
  settingHaptics: "setting-haptics",
  settingAnimationSpeed: "setting-animation-speed",
  settingReducedMotion: "setting-reduced-motion",
  settingConfirmMove: "setting-confirm-move",
  settingHints: "setting-hints",
  settingHighContrast: "setting-high-contrast",
  settingCoords: "setting-coords",
  settingPassDevice: "setting-pass-device",
  settingResetData: "setting-reset-data",

  // Practice
  practicePage: "practice-page",
  practicePit: (r, c) => `practice-pit-r${r}-c${c}`,
  practiceLoadBtn: "practice-load-btn",
  practiceSaveBtn: "practice-save-btn",
  practiceResetBtn: "practice-reset-btn",
  practiceCodeInput: "practice-code-input",
  practiceTogglePlayer: "practice-toggle-player",
};

// Backwards compat for the default starter
export const HOME = { emergentLink: "emergent-link" };
